import { render, staticRenderFns } from "./ParallelForum.vue?vue&type=template&id=7096c7ab&scoped=true&"
import script from "./ParallelForum.vue?vue&type=script&lang=js&"
export * from "./ParallelForum.vue?vue&type=script&lang=js&"
import style0 from "./ParallelForum.vue?vue&type=style&index=0&id=7096c7ab&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7096c7ab",
  null
  
)

export default component.exports